import React, { FunctionComponent } from 'react'
import DartsWinner, { BasicDartsWinnerProps } from '..'

export type SetWinnerProps = {
    /** quote of doubles in the set */
    doubleQuote: string
} & BasicDartsWinnerProps

const SetWinner: FunctionComponent<SetWinnerProps> = ({
    doubleQuote,
    playerImageAlt,
    playerName,
    playerImageUrl,
    countryImageUrl,
    countryImageAlt,
    threeDartsAverage,
}) => (
    <DartsWinner
        winningType="Set"
        playerName={playerName}
        doubleQuote={doubleQuote}
        threeDartsAverage={threeDartsAverage}
        playerImageAlt={playerImageAlt}
        playerImageUrl={playerImageUrl}
        countryImageUrl={countryImageUrl}
        countryImageAlt={countryImageAlt}
    />
)
export default SetWinner
